import type { ReactNode } from 'react'

import ComingSoon from '@/features/bidding/components/cascading/ComingSoon'
import type { CascadeMarketId } from '@/features/bidding/types/market'

type MarketFeatureGuardProps = {
  selectedMarket: CascadeMarketId
  children: ReactNode
}

/**
 * Wrapper component that shows "Coming soon" for markets that are not fully implemented.
 * Currently mFRR, FCR-D, and FCR-N are fully implemented, other markets show the coming soon message.
 */
function MarketFeatureGuard({ selectedMarket, children }: Readonly<MarketFeatureGuardProps>) {
  const enabledMarkets: CascadeMarketId[] = ['mfrr', 'fcr-d', 'fcr-n']

  if (!enabledMarkets.includes(selectedMarket)) {
    return <ComingSoon />
  }

  return <>{children}</>
}

export default MarketFeatureGuard
